import { randomString } from 'sma.common/utils';
const bulkUrl = reverse('surveys-bulk');
const Modals = require('sma.common/components/modals');

const Option = $.klass({
	label: undefined,
	inContextMenu: false,
	help: undefined,
	optional: true,
	enabled: true,
	classes: 'option clearfix',

	initialize: function(field, config) {
		if (field !== undefined && field.editor === undefined) {
			this.editor = field;
		} else if (field !== undefined) {
			this.field = field;
			this.editor = field.editor;
		}
		$.extend(this, config);
	},

	render: function() {
		return $('<div></div>')
			.addClass(this.classes);
	},

	renderHelp: function() {
		return (this.help) ? $(this.renderHelpString()) : undefined;
	},

	renderHelpString: function() {
		if (this.help !== undefined) {
			return ` <a href="#" class="help" title="${this.help}">(?)</a>`;
		}
		return '';
	}
});

Option.renderGroup = function(label, items, collapsed, delayed) {

var renderer = function(){
		var result = $('<div class="optgroup">').toggleClass('collapsable', collapsed !== undefined).toggleClass('collapsed', collapsed === true);
		if (label){
			var title = $('<h3 class="collapsable-title"/>').appendTo(result).append($('<a/>', {
				href: '#',
				text: label
			}).click(function(e){
				e.preventDefault();
				options.toggle(!result.toggleClass('collapsed').hasClass('collapsed'));

			}));
		}

		var options = $('<div/>');

		$.each(items, function(i, el){
			if (el) {
				options.append((el.render) ? el.render() : el);
			}
		});

		options.appendTo(result).toggle(!collapsed);

		return result;
	};
	return (!!delayed) ? { render: (function(){return (this.rendered = renderer.apply(this, arguments)); })} : renderer(label, items, collapsed);
};

Option.Collapsable = $.klass({
	classes: 'option collapsable-options',
	label: '',
	collapsed: false,
	id: '',

	initialize: function(config) {
		$.extend(this, config);
	},

	render: function(nodes) {
		return Option.renderGroup(this.label, nodes, this.collapsed);
	}
});

Option.Group = $.klass({
	classes: 'option-group clearfix',

	initialize: function(field, config) {
		if (field.editor === undefined) {
			this.editor = field;
		} else {
			this.field = field;
			this.editor = field.editor;
		}

		this.options = [];

		$.extend(this, config);
	},

	render: function() {
		const result = $('<div><\/div>')
			.addClass(this.classes);

		_.each(this.options, function(el) {
			result.append(el.render());
		});

		return result;
	}
});

Option.Value = $.klass(Option, {
	value: undefined,

	blockUpdate: false,

	initialize: function($super, field, config) {
		const that = this;

		$super(field, config);

		$(this).bind('change', function(e, value, old) {
			return that.changed(value, old);
		});
	},

	get: function() {
		return this.value;
	},

	set: function(value, propagate) {
		const old = this.get();

		this.value = value;
		if (propagate !== false){
			$(this).trigger('change', [value, old]);
		}

		if (this.input && this.refresh) {
			this.refresh();
		}
	},

	changed: function(value, old) { }
});

Option.Radio = $.klass(Option.Value, {
	display: 'radio',
	value: undefined,
	showLabel: false,
	choices: [],
	label: '',

	refresh: function(){
		this.input.val(this.get());
	},

	render: function($super) {
		const that = this;
		const id = randomString(10);

		if (this.display == 'radio') {
			this.choiceDisplay = $('<ul></ul>');

			_.each(this.choices, function(el, i) {
				that.choiceDisplay
					.append($.format('<li class="choice"><label for="{0}">' +
						'<input type="radio" id="{0}" value="{3}" name="{1}" /> ' +
						'<span class="choice-value">{2}</span></label></li>', [
						randomString(10),
						id,
						el[1],
						el[0]
					]));
			});

			this.input = $('input', this.choiceDisplay)
				.click(function() {
					//that.set($.getCheckedValue($('input', that.choiceDisplay)));
				});
			$.setCheckedValue($('input', this.choiceDisplay), this.get());

			if (!this.enabled) {
				$('input', this.choiceDisplay).attr('disabled', 'disabled');
			}
		} else {
			this.input = this.choiceDisplay = $('<select class="custom-select custom-select-sm"></select>');

			_.each(this.choices, function(el, i) {
				that.choiceDisplay
					.append($.format('<option value="{0}">{1}</option>', [
						el[0],
						el[1]
					]));
			});

			this.choiceDisplay
				.change(function() {
					that.set(that.choiceDisplay.selectedOptions().val());
				})
				.val(this.value);

			if (!this.enabled) {
				this.choiceDisplay.attr('disabled', 'disabled');
			}
		}

		let label = '';
		if (this.showLabel) {
			label = '<span class="option-label">' + this.label + '<\/span>';
		}

		return $super()
			.append(label)
			.append(this.choiceDisplay)
			.append(this.renderHelpString());
	}
});

Option.Multiple = $.klass(Option.Value, {
	display: 'checkbox',
	value: undefined,
	choices: [],
	label_getter: function(a, i) { return a[1]; },
	id_getter: function(a, i){ return a[0]; },
	render: function($super) {
		const that = this;
		$(this).css('display', this.display);
		if (this.display == 'checkbox') {
			this.choiceDisplay = $('<ul></ul>');
			_.each(this.choices, function(el, i) {
				that.choiceDisplay
					.append($.format('<li class="choice"><label for="{0}">' +
						'<input type="checkbox" id="{0}" value="{3}" name="{1}" /> ' +
						'<span class="choice-value">{2}</span></label></li>', [
						randomString(10),
						el.id,
						that.label_getter(el),
						that.id_getter(el, i)
					]));
			});

			$('input', this.choiceDisplay)
				.change(function() {
					that.set($('input:checked', that.choiceDisplay).map(function() { return $(this).val(); }));
				});

			$('input', this.choiceDisplay).prop('checked', false);

			$.each(this.value || [], function() {
				$('input', that.choiceDisplay).eq(this).prop('checked', true);
			});
		} else {
			this.choiceDisplay = $('<select multiple="multiple"></select>');

			_.each(this.choices, function(el, i) {
				that.choiceDisplay
					.append($.format('<option value="{0}">{1}</option>', [
						el[0],
						el[1]
					]));
			});

			this.choiceDisplay
				.change(function() {
					that.set(that.choiceDisplay.selectedOptions().val());
				})
				.selectOptions(this.value);
		}
		if (this.hide) {
			return $super()
				.append(this.choiceDisplay)
				.css('display', 'none');
		}
		return $super().append(this.choiceDisplay);
	}
});

const Bulk = {
	presets: undefined,
	custom: undefined,
	languages: undefined,
	availableOptions : ['static', 'other', 'other_required', 'optional', 'alphabetize', 'randomize'],

	initialize: function() {
		const that = this;

		if (!this.languages) {
			this.languages = require('sma.fs/surveys/editor').Editor.instances[0].languages;
			this.lang_codes = $.map(this.languages.list, function(el,i) { return el.code; });
		}

		if (!this.presets || !this.custom) {
			this.lang_codes = $.map(this.languages.list, function(el,i) { return el.code; });
			this.presets = [];
			this.custom = [];

			$.ajax({
				async: false,
				url: bulkUrl,
				type: 'GET',
				dataType: 'json',
				data: {
					langs: $.map(this.languages.list, function(el, i) { return el.code; }),
					c: randomString(10)
				},
				success: function(data) {
					that.presets = data.presets;
					that.custom = data.custom;
				}
			});
		}
	},

	buildLoadSelect: function(type, callback) {
		const that = this;

		let el = $('<select>', { id: 'bulk-selector', class: 'custom-select ml-2' });

		el.append($('<option>', { text: '---', value: '-' }));

		let presets = $('<optgroup>', { label: gettext('Presets') }).appendTo(el);

		$.each(this.presets, function(i, el) {
			if (el.type.indexOf(type) >= 0) {
				presets.append($('<option>', { text: el.name, value: el.name, data: {bulk: el.values, cust: false} }));
			}
		});

		if (this.custom.length) {
			let custom = $('<optgroup>', { label: gettext('Custom') }).appendTo(el);

			$.each(this.custom, function(i, el) {
				custom.append($('<option>', { text: el.name, value: el.id, data: {bulk: el.values, cust: true} }));
			});
		}

		el.val('-').bind('change', function(e) {
			that._cached_id = undefined;

			let option_el = $(this).find('option[value="' + $(this).val() + '"]');

			callback.apply(this, [option_el.data('bulk'), option_el.data('cust')]);

			return false;
		});

		return el;
	},

	buildTexts: function() {
		let texts = {};

		$.each(this.languages.list, function(i, el) {
			texts[el.code] = $('<textarea/>').addClass('edit');
		});

		return texts;
	},

	setTextsFromValue: function(texts, value) {
		let langs = this.languages;
		let that = this;
		let defaultLanguage = this.languages.defaultLanguage().code;
		let printOptions = function (el) {
			//return a string to append options to bulk variables
			let options = [];
			if (el.score && el.score.value != undefined) {
				options.push(el.score.value);
			}
			$.each(that.availableOptions, function(i, keyword) {
				if (el[keyword] && el[keyword].value) {
					options.push(keyword);
				}
			});
			if (options.length > 0) {
				return ' | ' + options.join(' | ');
			}
			return '';
		};

		const addQuestionType = function (ele) {
			if (ele.type && ele.type.value) {
				return ' [[' + ele.type.value + ']]';
			}

			return '';
		};

		$.each(langs.list, function(i, el) {
			let code = el.code;
			texts[code].val($.map(value, function(ele, j) {
				//presets are just simple objects
				let text = ((ele.text && ele.text.value) ? ele.text.value : null) || ele;
				var variableId = '';

				if (ele.type !== undefined) {
					variableId = '[*A' + (j + 1) + '*] ';
				}

				if (text) {
					if(code === defaultLanguage){
						return variableId + langs.translate(text, code) + addQuestionType(ele) + printOptions(ele);
					}
					return langs.translate(text, code);
				}
			}).join('\r\n'));
		});

	},

	valueFromTexts: function(texts) {
		let val = {};

		$.each(this.languages.list, function(i, el) {
			val[el.code] = texts[el.code].val().split('\r\n').join('\n').split('\r').join('\n').split('\n');
		});

		let result = [];

		let defaultLang = this.languages.defaultLanguage();

		$.each(this.languages.list, function(i, el) {
			if (val[el.code].length != val[defaultLang.code].length) {
				throw interpolate(gettext(
					'Bulk list for language "%s" does not have the same number of elements as the default language.'),
				[el.name]);
			}
		});

		for (let i = 0; i < val[defaultLang.code].length; i++) {
			result[i] = {};
			for (let j = 0; j < this.languages.list.length; j++) {
				result[i][this.languages.list[j].code] = val[this.languages.list[j].code][i];
			}
		}

		return result;
	},

	show: function(type, value, callback) {
		var that      = this,
		allAttributes = value,	//value is now pased as all attributes so we can access scores + others
		dialog        = $('<div>'),
		langSelect    = false,
		needsIndex    = false;

		var printOptions = function () {
			var options = new Set([]);
			$.each(Bulk.availableOptions, function(i, v) {
				$.each(allAttributes, function(j, attribute) {
					if (attribute[v]) {
						options.add(v);
					}
				})
			});

			return $('<ul/>').append(
				options.has('optional') ? $('<li/>').append(gettext(
					'Make an item <b>optional</b> by appending "| optional" after the label (e.g. <b>Age | optional</b>)'
				)) : false,
				options.has('alphabetize') || options.has('randomize') ? $('<li/>').append(gettext(
					'<b>Randomize</b> or <b>alphabetize</b> the choices within a variable by appending ' +
					'"| randomize" or "| alphabetize" after the label. (e.g. <b>Preference | alphabetize</b>)'
				)) : false,
				options.size == 0 ? $('<li/>').append(gettext(
					'Add a <b>score</b> value to an item by appending "|" and the score after the label ' +
					'(e.g. <b>apples | 10</b>)'
				)) : false
			);
		}

		value = $.map(value, function(el, i) {
			//map value to its original purpose
			return el.text.value;
		});

		this.initialize();

		if (allAttributes.length > 0 && allAttributes[0].type !== undefined) {
			needsIndex = true;
		}

		var	bulk = this.buildTexts();
		var defaultLang = this.languages.defaultLanguage();

		this.setTextsFromValue(bulk, allAttributes);

		var loadSelect = this.buildLoadSelect(type, function(val, cust) {
			if (cust) {
				$('#bulk-name').val($('option:selected', this).text())
			} else {
				$('#bulk-name').val($('', this).text())
			}

			if ($(this).find(':selected').parent().prop('tagName').toLowerCase() == 'optgroup' && $(this).find(':selected').parent().attr('label') =='Custom')
				that._cached_id = $(this).val();
			else
				that._cached_id = undefined;

			that.setTextsFromValue(bulk, val);
		});

		if (this.languages.list.length > 1) {
			langSelect = $('<select/>', {'class': 'custom-select'});

			var curLang = false;
			var langLabel = '';

			$.each(this.languages.list, function(i, el) {
				if (el.code === defaultLang.code) {
					langLabel = $('<h3/>').addClass('bulk-current-lang').html(el.name);
				} else {
					$('<option/>', { value: el.code, text: el.name }).appendTo(langSelect);

					if (!curLang) {
						langSelect.val(curLang = el.code);
					}
				}
			});

			dialog.addClass('sidebyside');

			var loaded = langSelect.val();

			langSelect.change(function(e) {
				bulk[loaded].replaceWith(bulk[$(this).val()]);

				loaded = $(this).val();
			});
		}

		var nameInput = $('<input type="text" id="bulk-name" class="form-control" />');
		var buttons = [{
			cls: 'btn-primary',
			label: gettext('OK'),
			handler: function(modal) {
				try {
					var value = that.valueFromTexts(bulk);
				} catch (e) {

					new sma.components.Alert({
						message: e,
						type: 'danger'
					});

					return false;
				}

				var data = {
					name: nameInput.val(),
					values: JSON.stringify(value)
				}

				if (that._cached_id) {
					data.id = that._cached_id;
				}

				callback(value);
				modal.hide();
				}
			}, {
				'cls': 'btn-default',
				label: gettext('Cancel'),
				handler: function(modal) {
					modal.hide();
				}
			}, {
				'cls': 'btn-primary',
				label: gettext('Save'),
				handler: function(modal) {
					try {
						var value = that.valueFromTexts(bulk);
					} catch (e) {
						new sma.components.Alert({
							message: e,
							type: 'danger'
						});
						return false;
					}

					var data = {
						name: nameInput.val(),
						values: JSON.stringify(value)
					}

					if (that._cached_id) {
						data.id = that._cached_id;
					}

					if (nameInput.val()) {
						$.ajax({
							async: false,
							url: bulkUrl,
							type: 'POST',
							dataType: 'json',
							data: data,
							success: function(data) {
								if (!data.success) {
									throw new Error();
								}
								if (that._cached_id) {
									for (var i = 0; i < that.custom.length; i++) {
										if (that.custom[i].id == that._cached_id) {
											that.custom[i].values = value;
											that.custom[i].name =  nameInput.val();
											$('.bulk option[value='+that.custom[i].id +']').text(that.custom[i].name).data('bulk',that.custom[i].values);
											break;
										}
									}
								}
								else{
									that.custom.push({id:data.bulk,name:nameInput.val(),values:value});
									$('.bulk optgroup[label=Custom]').append($('<option>', { text: nameInput.val(), value: data.bulk, data: {bulk: value, cust: true} }));
								}

								new sma.components.Alert({
									message: gettext("Bulk List Saved Successfully"),
									type: 'success'
								});
							}
						});
					} else {
						new sma.components.Alert({
							message: gettext("Bulk List Name Required"),
							type: 'danger'
						});
					}
				}
			}, {
				'cls': 'btn-danger',
				label: gettext('Delete'),
				handler: function(modal) {

					if($(':selected', 'optgroup[label=Custom]').length == 1) {
						if(nameInput.val() != $(':selected', 'optgroup[label=Custom]').html()) {
							nameInput.val("");
						}
					}

					if(!nameInput.val()) {
						if($(':selected', 'optgroup[label=Custom]').length == 1) {
							nameInput.val($(':selected', 'optgroup[label=Custom]').html());
						}
					}

					if (nameInput.val()) {
						try {
							var value = that.valueFromTexts(bulk);
						} catch (e) {
							 return false;
						}

						var data = {
							name: nameInput.val(),
							action: 'delete',
							values: JSON.stringify(value)
						}

						if (that._cached_id) {
							data.id = that._cached_id;
						}

						var outerscope = this;

						new Modals.Confirm(gettext('Delete List'), gettext("Are you sure you'd like to delete this list? This action cannot be undone."), function() {
							$.ajax({
								async: false,
								url: bulkUrl,
								type: 'POST',
								dataType: 'json',
								data: data,
							   success: function(data) {
									if (!data.success) {
										throw new Error();
									}
									// lazy way of making custom bulks reload next time the dialog is shown
									that._cached_id = undefined;
									that.custom = undefined;
									modal.hide();
								}
							});
						});

						callback(value);
					} else {
						alert(gettext('Cannot delete non-custom bulk presets'));
					}
					that.custom = undefined;
					that._cached_id = undefined;
				}
			}];

		var modalOptions = {
			title: gettext('Bulk Editor'),
			buttons: buttons,
			autoShow: true,
			destroyOnClose: true,
		};

		let bulkEdit = $('<div class="row mb-3 mt-5"></div>')
			.append($('<div class="col-6">', {'class': 'lang clearfix'}).append(langLabel))
			.append($('<div class="col-6">', {'class': 'lang clearfix'}).append(langSelect));
	
		var modalContent = $('<div/>').append(
			$('<p/>').append('<label for="bulk-selector">' + gettext('Load preset or saved bulk:') + '<\/label>', loadSelect),
			$('<p/>').append('<label for="bulk-name">' + gettext('Enter a name to save as custom:') + '<\/label>', nameInput),
			needsIndex ? $('<div/>').append(gettext('Specify the variable type with "[[type]]" after the label. Type options are: single, dropdown, checkbox, and string.')) : false,
			$('<p/>').append($('<b/>').append("</br>" + gettext("Options:"))),
			printOptions(),
			(needsIndex
				? $('<div class="callout callout-warning" role="alert"/>').append(
						gettext(
							"<b>Do not modify the identifier shown at the beginning of each item (e.g. [*A1*]).</b> " +
							"If you want to change the order, select and move the entire line including the identifier. " +
							"Additionally, when adding a new item, do not include an identifier."
						)
					)
				: false
			),
			(langSelect) ? bulkEdit : false,
			$('<div>', {'class': 'row'})
				.append($('<p/>', {'class': 'col-6 edit bulk-edit'}).append(bulk[defaultLang.code]))
				.append((langSelect) ? $('<p>', {'class': 'col-6 edit bulk-edit'}).append(bulk[langSelect.val()]) : false)
		);

		var modal = new Modals.ContentModal(modalContent, modalOptions);
	}
};

module.exports = {
	Bulk: Bulk,
	Option: Option
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.fs/surveys/options.js